// Texty homepage — slovenské dvojče locale/cs/homepage.js.
import { number, currency, NBSP } from '../../modules/money.js';

function amountText(n) {
  const c = currency();
  const v = number(n);
  return c.left ? c.symbol + v : v + ' ' + c.symbol;
}

export default {
  hero: {
    label: 'Akciové ponuky',
    next: 'Ďalšie ponuky',
    dotPrefix: 'Prejsť na ponuku ',
  },
  intro: {
    title: 'Kvalitné náradie, autodoplnky a záhradná technika',
    subBefore: 'Za ',
    subAccent: 'najlepšie ceny',
    // cena = nejlevnější výdejní místo z ceníku manifestu (SK 5,19 €)
    subAfter: (shipFrom) => ' na slovenskom trhu, skladom a s dopravou od ' + amountText(shipFrom) + '.',
  },
  row: {
    leadSub: 'Najčastejšie kupované u nás',
    all: 'Zobraziť všetko',
    prev: 'Predchádzajúce produkty',
    next: 'Ďalšie produkty',
  },
  sale: {
    eyebrow: 'Zľavnené, len do vypredania zásob',
    cdLabel: 'Platnosť ponúk končí za',
    cdUnits: ['dni', 'hod', 'min', 'sek'],
    ctaWithCount: (n) => 'Všetkých ' + n + ' zľavnených produktov',
    ctaPlain: 'Zobraziť všetky zľavnené produkty',
  },
  bento: {
    b2b: {
      eyebrow: 'Pre firmy a remeselníkov',
      title: 'B2B spolupráca až −15' + NBSP + '%',
      text: 'Veľkoobchodné ceny na celý sortiment. Zaregistrujte firmu a nakupujte výhodnejšie.',
      cta: 'Registrácia firmy',
    },
    sale: {
      title: 'Zľavy až −40 % v kategórii Zľavoakcia',
      text: 'Zľavnený tovar skladom, len do vypredania zásob.',
      cta: 'Zistiť viac',
    },
  },
  articles: {
    title: 'Rady a návody',
    all: 'Všetky články',
  },
  about: {
    eyebrow: 'O nás',
    title: 'Pretože náradie musí hlavne vydržať.',
    ctaLabel: 'O predajni',
    badgeTitle: 'Predajňa & servis',
  },
  // nadpis řady v adminu SK je „Zľavy" (dev/sk/home.html, 22. 9.), kategorie /zlavoakcia/
  rowLinkSale: /zľavoakcia|zlavoakcia|^zľavy$/i,
  rowLinkClearance: /výpredaj|vypredaj/i, // SK: neověřeno ve fixtures
  leadRowMatch: /najobľúben|najpredávan|najobluben|najpredavan/i, // SK: neověřeno ve fixtures
  saleMatch: /zľavoakcia|zlavoakcia|^zľavy$/i,
  catCountRe: new RegExp(
    "[ " + NBSP + "]*[·|,–-]?[ " + NBSP + "]*([0-9][0-9 " + NBSP + "]*)[ " + NBSP + "]+(produkt|produkty|produktov)[ " + NBSP + "]*$",
    'i'
  ),
};
